import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import AleaIconButton from '../../../components/AleaIconButton/AleaIconButton';
import AleaDownloadIcon from '../../../icons/AleaDownloadIcon';

export interface AnalysisContentSectionProps {
  titleKey: string;
  descriptionKey: string;
  downloadLabelKey?: string;
  onDownloadClick?: () => void;
  secondDownloadLabelKey?: string;
  onSecondDownloadClick?: () => void;
  actionIcon?: React.ReactNode;
  actionGap?: string;
  exportBlocked?: boolean;
  exportBusy?: boolean;
}

const AnalysisContentSection: React.FC<AnalysisContentSectionProps> = ({
  titleKey,
  descriptionKey,
  downloadLabelKey = 'general.exportAsPdf',
  onDownloadClick = () => {},
  secondDownloadLabelKey,
  onSecondDownloadClick = () => {},
  actionIcon,
  actionGap,
  exportBlocked = false,
  exportBusy = false,
}) => {
  const { t } = useTranslation();
  const actionsDisabled = exportBlocked || exportBusy;
  const buttonIcon = actionIcon ?? (
    <AleaDownloadIcon size="22" color="white" />
  );

  const defaultGap = { base: '12px', md: '16px' };
  const columnGap = actionGap ?? defaultGap;
  const rowGap = actionGap ? '15px' : defaultGap;

  return (
    <Box>
      <Flex direction="column" align="flex-start" gap="0" mb="25px">
        <Text fontSize="25px" fontWeight="500" color="black" mb="0">
          {t(titleKey)}
        </Text>
        <Text fontSize="18px" fontWeight="normal" color="black" mb="0">
          {t(descriptionKey)}
        </Text>
      </Flex>
      <Flex
        direction="row"
        flexWrap="wrap"
        align="center"
        columnGap={columnGap}
        rowGap={rowGap}
      >
        <AleaIconButton
          icon={buttonIcon}
          gap={actionIcon ? '10px' : undefined}
          onClick={onDownloadClick}
          aria-label={t(downloadLabelKey)}
          isDisabled={actionsDisabled}
        >
          {t(downloadLabelKey)}
        </AleaIconButton>
        {secondDownloadLabelKey ? (
          <AleaIconButton
            icon={buttonIcon}
            gap={actionIcon ? '10px' : undefined}
            onClick={onSecondDownloadClick}
            aria-label={t(secondDownloadLabelKey)}
            isDisabled={actionsDisabled}
          >
            {t(secondDownloadLabelKey)}
          </AleaIconButton>
        ) : null}
      </Flex>
    </Box>
  );
};

export default AnalysisContentSection;
